import { PromotionRewardTarget } from '../RegistrationOfferImage/RegistrationOfferImage.constants';
import { z } from '@betty/toolkit/api';
import icons from '@betty/moonlight/lib/assets/icons';
import { PromoTargetSchema } from '@betty/promos';

export const rewardBadgeMap: Partial<
  Record<z.infer<typeof PromoTargetSchema>, keyof typeof icons>
> = {
  FreeSpins: 'freeSpins',
  Coins: 'bettyCoin',
  InstantWheel: 'rewardWheel',
  Cash: 'bettyDollar',
};

export const rewardBadgeDataMap = {
  [PromotionRewardTarget.FreeSpins]: {
    iconName: rewardBadgeMap.FreeSpins,
    rewardName: 'Free Spins',
  },
  [PromotionRewardTarget.Coins]: {
    iconName: rewardBadgeMap.Coins,
    rewardName: 'Betty Coins',
  },
  [PromotionRewardTarget.InstantWheel]: {
    iconName: rewardBadgeMap.InstantWheel,
    rewardName: 'Wheel Spins',
  },
  [PromotionRewardTarget.Cash]: {
    iconName: rewardBadgeMap.Cash,
    rewardName: 'Cash',
  },
};
